/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "address",
                name: "memberAddress",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "claimAll",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "connectPool",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "bool",
                        name: "transferabilityForUnitsOwner",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "distributionFromAnyAddress",
                        type: "bool",
                    },
                ],
                internalType: "struct PoolConfig",
                name: "config",
                type: "tuple",
            },
        ],
        name: "createPool",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "disconnectPool",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "requestedAmount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "distribute",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "int96",
                name: "requestedFlowRate",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "distributeFlow",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "requestedAmount",
                type: "uint256",
            },
        ],
        name: "estimateDistributionActualAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "to",
                type: "address",
            },
            {
                internalType: "int96",
                name: "requestedFlowRate",
                type: "int96",
            },
        ],
        name: "estimateFlowDistributionActualFlowRate",
        outputs: [
            {
                internalType: "int96",
                name: "actualFlowRate",
                type: "int96",
            },
            {
                internalType: "int96",
                name: "totalDistributionFlowRate",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "to",
                type: "address",
            },
        ],
        name: "getFlowDistributionFlowRate",
        outputs: [
            {
                internalType: "int96",
                name: "",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getNetFlow",
        outputs: [
            {
                internalType: "int96",
                name: "",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
        ],
        name: "getPoolAdjustmentFlowInfo",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "int96",
                name: "",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pool",
                type: "address",
            },
        ],
        name: "getPoolAdjustmentFlowRate",
        outputs: [
            {
                internalType: "int96",
                name: "",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "address",
                name: "member",
                type: "address",
            },
        ],
        name: "isMemberConnected",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isPool",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "address",
                name: "memberAddress",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "newUnits",
                type: "uint128",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "updateMemberUnits",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class GDAv1Forwarder__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
GDAv1Forwarder__factory.bytecode = _bytecode;
GDAv1Forwarder__factory.abi = _abi;
//# sourceMappingURL=GDAv1Forwarder__factory.js.map